// @flow
import React from "react";
import type { RoomId } from "src/types";
import Standard from "./Standard";
import Custom from "./Custom";

type BadgeProps = {
  activeStatus: boolean,
  value: number,
  roomId: RoomId,
  location: string,
  overdue: boolean,
  allowTooltip: boolean,
  toggleStatus: () => void,
  customCss?: string,
};

const Badge = ({
  activeStatus,
  value,
  roomId,
  location,
  overdue,
  allowTooltip,
  toggleStatus,
  customCss,
}: BadgeProps) => {
  return (
    <div
      tabIndex="0"
      role="button"
      data-cy="status"
      onClick={() => {
        allowTooltip && toggleStatus();
      }}
      onKeyPress={() => {
        allowTooltip && toggleStatus();
      }}
    >
      {value < 0 ? (
        <Standard
          id={value}
          roomId={roomId}
          location={location}
          isOverDue={overdue}
          active={activeStatus}
          customCss={customCss}
        />
      ) : (
        <Custom
          id={value}
          roomId={roomId}
          location={location}
          isOverDue={overdue}
          active={activeStatus}
          customCss={customCss}
        />
      )}
    </div>
  );
};

export default Badge;
